import "./App.css";
import { Entry } from "../src/pages/Entry";
import { Dashboard } from "../src/pages/Dashboard";
import { AddTicket } from "../src/pages/AddTicket";
import { TicketList } from "../src/pages/TicketList";
import { TicketPage } from "../src/pages/TicketPage";
import { DefaultLayout } from "./pages/DefaultLayout";
import { useSelector } from "react-redux";
import { ResetPage } from "./pages/ResetPage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

function App() {
  const { isAuth } = useSelector((state) => state.login);
  // const isAuth = true;

  return (
    <div className="App">
      <Router>
        <DefaultLayout>
          <Routes>
            <Route exact path="/" element={<Entry />} />
            <Route
              path="/dashboard"
              element={
                isAuth || sessionStorage.getItem("accessJwt") ? (
                  <Dashboard />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/addticket"
              element={
                isAuth || sessionStorage.getItem("accessJwt") ? (
                  <AddTicket />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/ticketlist"
              element={
                isAuth || sessionStorage.getItem("accessJwt") ? (
                  <TicketList />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/ticketpage/:tId"
              element={
                isAuth || sessionStorage.getItem("accessJwt") ? (
                  <TicketPage />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route path="/ResetPage" element={<ResetPage />} />
          </Routes>
        </DefaultLayout>
      </Router>
    </div>
  );
}

export default App;
